import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { getNextServiceWithPermission } from '@chancenwerk/shared/permissions.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { switchMap } from 'rxjs';
import '../design/components/cr-button.js';
import '../design/components/cr-flex.js';
import '../design/components/cr-image.js';
import '../design/components/fonts.js';
import type { AdornisUser } from '@adornis/users/db/a-user.js';

/**
 * @customElement chancen-page-no-permission
 */
@customElement('chancen-page-no-permission')
export class ChancenPageNoPermission extends ChemistryLitElement {
  @state() private readonly _size = new WindowSizeController(this);
  @state() private readonly _currentUser = new RXController(this, currentUser<AdornisUser>());
  @state() private readonly _rerouteLink = new RXController(
    this,
    this._currentUser.observable.pipe(
      switchMap(user => {
        return getNextServiceWithPermission(user?._id ?? '');
      }),
    ),
  );

  override render() {
    return html`
      <cr-flex padding="${this._size.mobile ? 'md' : 'xxl'}" space="xl" center crossaxis-center>
        ${this._content()}
      </cr-flex>
    `;
  }

  private _content() {
    if (this._currentUser.isLoading || this._rerouteLink.isLoading) return html`<cr-loader></cr-loader>`;
    return html`
      <!-- <cr-image ${css({ width: '80%', maxWidth: '30rem' })} is-url mode="width"></cr-image> -->
      <cr-h3> Wie bist du denn hier gelandet? </cr-h3>
      <cr-text> Du besitzt nicht die benötigten Rechte diese Seite aufzurufen. </cr-text>
      <cr-button
        mode="action"
        icon="chevron_left"
        @click=${() => {
          if (this._rerouteLink.value) goTo(this._rerouteLink.value, { target: '_parent' });
        }}
      >
        Zurück zu deinem Bereich
      </cr-button>
    `;
  }
}
